/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileInfo,
    CaseFileInfoFromJSON,
    CaseFileInfoFromJSONTyped,
    CaseFileInfoToJSON,
    CaseFileType,
    CaseFileTypeFromJSON,
    CaseFileTypeFromJSONTyped,
    CaseFileTypeToJSON,
    CaseFolder,
    CaseFolderFromJSON,
    CaseFolderFromJSONTyped,
    CaseFolderToJSON,
    DocumentStatus,
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    ParentRelationship,
    ParentRelationshipFromJSON,
    ParentRelationshipFromJSONTyped,
    ParentRelationshipToJSON,
    Source,
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFile
 */
export interface CaseFile {
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    uploadedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    location?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseFile
     */
    uploadDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CaseFile
     */
    fileSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    parentDocumentId?: string | null;
    /**
     * 
     * @type {ParentRelationship}
     * @memberof CaseFile
     */
    parentRelationship?: ParentRelationship;
    /**
     * 
     * @type {Source}
     * @memberof CaseFile
     */
    source: Source;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    clientId?: string | null;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof CaseFile
     */
    status: DocumentStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFile
     */
    isArchived: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseFile
     */
    pageCount?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CaseFile
     */
    pageText?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    mimeType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFile
     */
    uploadedByClient: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFile
     */
    isWithheld: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFile
     */
    isPrivileged: boolean;
    /**
     * 
     * @type {CaseFileType}
     * @memberof CaseFile
     */
    type: CaseFileType;
    /**
     * 
     * @type {CaseFileInfo}
     * @memberof CaseFile
     */
    info?: CaseFileInfo;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    folderId?: string | null;
    /**
     * 
     * @type {CaseFolder}
     * @memberof CaseFile
     */
    folder?: CaseFolder;
    /**
     * 
     * @type {string}
     * @memberof CaseFile
     */
    hash?: string | null;
}

export function CaseFileFromJSON(json: any): CaseFile {
    return CaseFileFromJSONTyped(json, false);
}

export function CaseFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'uploadedBy': !exists(json, 'uploadedBy') ? undefined : json['uploadedBy'],
        'name': json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (new Date(json['uploadDate'])),
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'parentDocumentId': !exists(json, 'parentDocumentId') ? undefined : json['parentDocumentId'],
        'parentRelationship': !exists(json, 'parentRelationship') ? undefined : ParentRelationshipFromJSON(json['parentRelationship']),
        'source': SourceFromJSON(json['source']),
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'status': DocumentStatusFromJSON(json['status']),
        'isArchived': json['isArchived'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'pageText': !exists(json, 'pageText') ? undefined : json['pageText'],
        'mimeType': !exists(json, 'mimeType') ? undefined : json['mimeType'],
        'uploadedByClient': json['uploadedByClient'],
        'isWithheld': json['isWithheld'],
        'isPrivileged': json['isPrivileged'],
        'type': CaseFileTypeFromJSON(json['type']),
        'info': !exists(json, 'info') ? undefined : CaseFileInfoFromJSON(json['info']),
        'folderId': !exists(json, 'folderId') ? undefined : json['folderId'],
        'folder': !exists(json, 'folder') ? undefined : CaseFolderFromJSON(json['folder']),
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
    };
}

export function CaseFileToJSON(value?: CaseFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'uploadedBy': value.uploadedBy,
        'name': value.name,
        'location': value.location,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate.toISOString()),
        'fileSize': value.fileSize,
        'parentDocumentId': value.parentDocumentId,
        'parentRelationship': ParentRelationshipToJSON(value.parentRelationship),
        'source': SourceToJSON(value.source),
        'caseId': value.caseId,
        'clientId': value.clientId,
        'status': DocumentStatusToJSON(value.status),
        'isArchived': value.isArchived,
        'pageCount': value.pageCount,
        'pageText': value.pageText,
        'mimeType': value.mimeType,
        'uploadedByClient': value.uploadedByClient,
        'isWithheld': value.isWithheld,
        'isPrivileged': value.isPrivileged,
        'type': CaseFileTypeToJSON(value.type),
        'info': CaseFileInfoToJSON(value.info),
        'folderId': value.folderId,
        'folder': CaseFolderToJSON(value.folder),
        'hash': value.hash,
    };
}


